/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypePrelevement } from './TypePrelevement';
import {
    TypePrelevementFromJSON,
    TypePrelevementFromJSONTyped,
    TypePrelevementToJSON,
    TypePrelevementToJSONTyped,
} from './TypePrelevement';
import type { TypeEcheance } from './TypeEcheance';
import {
    TypeEcheanceFromJSON,
    TypeEcheanceFromJSONTyped,
    TypeEcheanceToJSON,
    TypeEcheanceToJSONTyped,
} from './TypeEcheance';
import type { TarificationBeneficiaireDto } from './TarificationBeneficiaireDto';
import {
    TarificationBeneficiaireDtoFromJSON,
    TarificationBeneficiaireDtoFromJSONTyped,
    TarificationBeneficiaireDtoToJSON,
    TarificationBeneficiaireDtoToJSONTyped,
} from './TarificationBeneficiaireDto';

/**
 * Rémunération portée par une garantie dans le détail de tarification.
 * @export
 * @interface RemunerationTarifDto
 */
export interface RemunerationTarifDto {
    /**
     * 
     * @type {string}
     * @memberof RemunerationTarifDto
     */
    remunerationId?: string;
    /**
     * 
     * @type {string}
     * @memberof RemunerationTarifDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RemunerationTarifDto
     */
    natureCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RemunerationTarifDto
     */
    montant?: number;
    /**
     * 
     * @type {TypePrelevement}
     * @memberof RemunerationTarifDto
     */
    typePrelevement?: TypePrelevement;
    /**
     * 
     * @type {TypeEcheance}
     * @memberof RemunerationTarifDto
     */
    typeEcheance?: TypeEcheance;
    /**
     * 
     * @type {TarificationBeneficiaireDto}
     * @memberof RemunerationTarifDto
     */
    beneficiaire?: TarificationBeneficiaireDto;
}



/**
 * Check if a given object implements the RemunerationTarifDto interface.
 */
export function instanceOfRemunerationTarifDto(value: object): value is RemunerationTarifDto {
    return true;
}

export function RemunerationTarifDtoFromJSON(json: any): RemunerationTarifDto {
    return RemunerationTarifDtoFromJSONTyped(json, false);
}

export function RemunerationTarifDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemunerationTarifDto {
    if (json == null) {
        return json;
    }
    return {
        
        'remunerationId': json['remunerationId'] == null ? undefined : json['remunerationId'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'natureCode': json['natureCode'] == null ? undefined : json['natureCode'],
        'montant': json['montant'] == null ? undefined : json['montant'],
        'typePrelevement': json['typePrelevement'] == null ? undefined : TypePrelevementFromJSON(json['typePrelevement']),
        'typeEcheance': json['typeEcheance'] == null ? undefined : TypeEcheanceFromJSON(json['typeEcheance']),
        'beneficiaire': json['beneficiaire'] == null ? undefined : TarificationBeneficiaireDtoFromJSON(json['beneficiaire']),
    };
}

export function RemunerationTarifDtoToJSON(json: any): RemunerationTarifDto {
    return RemunerationTarifDtoToJSONTyped(json, false);
}

export function RemunerationTarifDtoToJSONTyped(value?: RemunerationTarifDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remunerationId': value['remunerationId'],
        'libelle': value['libelle'],
        'natureCode': value['natureCode'],
        'montant': value['montant'],
        'typePrelevement': TypePrelevementToJSON(value['typePrelevement']),
        'typeEcheance': TypeEcheanceToJSON(value['typeEcheance']),
        'beneficiaire': TarificationBeneficiaireDtoToJSON(value['beneficiaire']),
    };
}

